import { useUserAuth } from "../../context/UserAuthContext"
import { UserTypeEnum } from "../../swagger"
import { Navigate } from "react-router-dom"


interface Props {
  children: React.ReactNode
  requiredRole?: UserTypeEnum
}

export const ProtectedRoute = ({ children, requiredRole }: Props) => {
  const { isAuthenticated, userType, loading } = useUserAuth()

  if (loading) return null // or <Loader /> if you want

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (requiredRole && userType !== requiredRole) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
